import {MenuItemAggregate} from '../../../../../aggregats/menu/menu-item.aggregate';
import {
  entreprisesSousMenuItem,
  formateursSousMenuItem,
  personnesSousMenuItem,
} from './sous-menu-items.constantes';

export const relationClientsMenuItem: MenuItemAggregate = new MenuItemAggregate(
  'icon-users',
  'Relation clients',
  [
    personnesSousMenuItem,
    entreprisesSousMenuItem,
    formateursSousMenuItem,
  ],
);
